import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/daisy';
import { Colors } from '@/components/ui/types';
import { AssessmentItemTypeEnum } from '@/models/Assessment';

type AssessmentItemTypeBadgeProps = {
  type: AssessmentItemTypeEnum;
};

const typeToColor: Record<AssessmentItemTypeEnum, Colors> = {
  [AssessmentItemTypeEnum.MANUAL]: 'accent',
  [AssessmentItemTypeEnum.DIGITAL_ACTIVITY]: 'info',
  [AssessmentItemTypeEnum.TEST]: 'success',
};

const typeToTextKey: Record<AssessmentItemTypeEnum, string> = {
  [AssessmentItemTypeEnum.MANUAL]: 'assessmentItemTypeManual',
  [AssessmentItemTypeEnum.DIGITAL_ACTIVITY]:
    'assessmentItemTypeDigitalActivity',
  [AssessmentItemTypeEnum.TEST]: 'assessmentItemTypeTest',
};

export default function AssessmentItemTypeBadge({
  type,
}: AssessmentItemTypeBadgeProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.evaluationsTab',
  });

  return (
    <Badge
      color={typeToColor[type]}
      variant="soft"
      size="sm"
      className="text-nowrap"
    >
      {t(typeToTextKey[type])}
    </Badge>
  );
}
